export const defaultBufferFilters = {
  search: '',
  league: '',
  timeWindow: 'any',
  sort: 'kickoffAsc',
  advanced: {
    handicapTrend: 'all',
    oddsDelta: '',
    goalLine: 'any',
    updatedWithin: 'any',
  },
}

export const bufferSortingOptions = [
  { value: 'kickoffAsc', label: 'Kick-off (earliest)' },
  { value: 'kickoffDesc', label: 'Kick-off (latest)' },
  { value: 'leagueAsc', label: 'League (A-Z)' },
  { value: 'leagueDesc', label: 'League (Z-A)' },
  { value: 'handicap', label: 'Handicap movement' },
  { value: 'oddsDelta', label: 'Odds delta' },
]

export const bufferTimeOptions = [
  { value: 'any', label: 'Any time' },
  { value: 'live', label: 'Live or in-play' },
  { value: '1h', label: 'Next 60 minutes' },
  { value: '3h', label: 'Next 3 hours' },
  { value: 'today', label: 'Today' },
  { value: 'tomorrow', label: 'Tomorrow' },
]

const now = new Date()
const hour = 60 * 60 * 1000

export const mockBufferEvents = [
  {
    id: 'EPL-2401',
    leagueId: 'EPL',
    leagueName: 'Premier League',
    leagueCountry: 'England',
    kickoff: new Date(now.getTime() + hour * 2).toISOString(),
    homeTeam: 'Manchester United',
    awayTeam: 'Chelsea',
    handicap: {
      line: -0.5,
      home: -0.5,
      away: 0.5,
    },
    homeOdds: 1.92,
    awayOdds: 1.98,
    goalLine: 2.5,
    goalOverOdds: 1.85,
    goalUnderOdds: 2.05,
    handicapTrend: 'dropping',
    oddsDelta: 0.08,
    lastSyncedAt: new Date(now.getTime() - 15 * 60 * 1000).toISOString(),
    parlayEligible: true,
    singleEligible: true,
    status: 'scheduled',
  },
  {
    id: 'LL-202',
    leagueId: 'LL',
    leagueName: 'La Liga',
    leagueCountry: 'Spain',
    kickoff: new Date(now.getTime() + hour * 5).toISOString(),
    homeTeam: 'Real Madrid',
    awayTeam: 'Sevilla',
    handicap: {
      line: -1,
      home: -1,
      away: 1,
    },
    homeOdds: 1.74,
    awayOdds: 2.15,
    goalLine: 3,
    goalOverOdds: 2.1,
    goalUnderOdds: 1.78,
    handicapTrend: 'rising',
    oddsDelta: 0.12,
    lastSyncedAt: new Date(now.getTime() - 5 * 60 * 1000).toISOString(),
    parlayEligible: true,
    singleEligible: true,
    status: 'scheduled',
  },
  {
    id: 'SERIEA-88',
    leagueId: 'SA',
    leagueName: 'Serie A',
    leagueCountry: 'Italy',
    kickoff: new Date(now.getTime() + hour * 25).toISOString(),
    homeTeam: 'Napoli',
    awayTeam: 'Juventus',
    handicap: {
      line: 0,
      home: 0,
      away: 0,
    },
    homeOdds: 2.05,
    awayOdds: 1.92,
    goalLine: 2.25,
    goalOverOdds: 1.96,
    goalUnderOdds: 1.94,
    handicapTrend: 'stale',
    oddsDelta: 0.02,
    lastSyncedAt: new Date(now.getTime() - 45 * 60 * 1000).toISOString(),
    parlayEligible: false,
    singleEligible: true,
    status: 'scheduled',
  },
  {
    id: 'J-LEAGUE-14',
    leagueId: 'J1',
    leagueName: 'J1 League',
    leagueCountry: 'Japan',
    kickoff: new Date(now.getTime() - hour / 2).toISOString(),
    homeTeam: 'Gamba Osaka',
    awayTeam: 'Kawasaki Frontale',
    handicap: {
      line: -0.25,
      home: -0.25,
      away: 0.25,
    },
    homeOdds: 2.12,
    awayOdds: 1.81,
    goalLine: 2.75,
    goalOverOdds: 1.88,
    goalUnderOdds: 2.02,
    handicapTrend: 'dropping',
    oddsDelta: 0.18,
    lastSyncedAt: new Date(now.getTime() - 3 * 60 * 1000).toISOString(),
    parlayEligible: true,
    singleEligible: true,
    status: 'live',
  },
  {
    id: 'MLS-901',
    leagueId: 'MLS',
    leagueName: 'Major League Soccer',
    leagueCountry: 'USA',
    kickoff: new Date(now.getTime() + hour * 10).toISOString(),
    homeTeam: 'LA Galaxy',
    awayTeam: 'Seattle Sounders',
    handicap: {
      line: -0.75,
      home: -0.75,
      away: 0.75,
    },
    homeOdds: 1.98,
    awayOdds: 1.92,
    goalLine: 3.25,
    goalOverOdds: 2.25,
    goalUnderOdds: 1.68,
    handicapTrend: 'rising',
    oddsDelta: 0.22,
    lastSyncedAt: new Date(now.getTime() - 90 * 60 * 1000).toISOString(),
    parlayEligible: true,
    singleEligible: false,
    status: 'scheduled',
  },
]

